import {
  GET_ALL_SETTINGS,
  ADD_SETTINGS,
  UPDATE_SETTINGS,
  UPDATE_STATUS_SETTINGS,
  DELETE_SETTINGS,
} from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_SETTINGS:
      return { ...state, list: payload };

    case UPDATE_SETTINGS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    case UPDATE_STATUS_SETTINGS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    case ADD_SETTINGS:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    case DELETE_SETTINGS:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };

    default:
      return state;
  }
};

export default reducer;
